/* eslint-disable no-unused-vars */
import React from 'react';
import {
  Pinterest,
  Snapchat,
  Instagram,
  Youtube,
  Tiktok,
  Facebook,
  Twitter,
  LinkedIn,
  Twitch,
  UgcPhoto,
  UgcVideo,
} from '../components/icons';
import Speaking from 'shared/components/icons/speaking';
import Podcast from 'shared/components/icons/podcast';

export enum SocialMediaNames {
  Instagram = 'Instagram',
  Facebook = 'Facebook',
  Tiktok = 'Tiktok',
  Twitter = 'Twitter',
  Pinterest = 'Pinterest',
  Snapchat = 'Snapchat',
  Youtube = 'Youtube',
  Linkedin = 'Linkedin',
  Twitch = 'Twitch',
  ugcvideo = 'ugcvideo',
  ugcphoto = 'ugcphoto',
  Speaking = 'Speaking',
  Podcast = 'Podcast',
}

export const getSocialIcon = (socialMediaName, size) => {
  switch (socialMediaName) {
    case SocialMediaNames.Instagram:
      return <Instagram width={size} height={size} iconColor='#1A1A1AFF' />;
    case SocialMediaNames.Facebook:
      return <Facebook width={size} height={size} iconColor='#1A1A1AFF' />;
    case SocialMediaNames.Tiktok:
      return <Tiktok width={size} height={size} iconColor='#1A1A1AFF' />;
    case SocialMediaNames.Twitter:
      return <Twitter width={size} height={size} iconColor='#1A1A1AFF' />;
    case SocialMediaNames.Pinterest:
      return <Pinterest width={size} height={size} iconColor='#1A1A1AFF' />;
    case SocialMediaNames.Snapchat:
      return <Snapchat width={size} height={size} iconColor='#1A1A1AFF' />;
    case SocialMediaNames.Youtube:
      return <Youtube width={size} height={size} iconColor='#1A1A1AFF' />;
    case SocialMediaNames.Linkedin:
      return <LinkedIn width={size} height={size} iconColor='#1A1A1AFF' />;
    case SocialMediaNames.Twitch:
      return <Twitch width={size} height={size} iconColor='#1A1A1AFF' />;
    case SocialMediaNames.ugcvideo:
      return <UgcVideo width={size} height={size} iconColor='#1A1A1AFF' />;
    case SocialMediaNames.ugcphoto:
      return <UgcPhoto width={size} height={size} iconColor='#1A1A1AFF' />;
    case SocialMediaNames.Speaking:
      return <Speaking width={size} height={size} iconColor='#1A1A1AFF' />;
    case SocialMediaNames.Podcast:
      return <Podcast width={size} height={size} iconColor='#1A1A1AFF' />;
    default:
      return (<></>);
  }
};